import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import classes from "./DisciplineEdit.module.css"
import { coursesApi } from "../../../../utils";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import BackArrow from "../../../UI/BackArrow";
import DisciplineEditDetails from "./DisciplineEditDetails";
import DisciplineEditTocs from "./DisciplineEditToc";
import { TabsMenu, Tab } from "../../../UI/TabsMenu";
import DynamicMessage from "../../../lms-shared/UI/Popups/DynamicMessage/DynamicMessage";

const DisciplineEdit = () => {
    const { disciplinId } = useParams();

    const componentMounted = useRef(true);
    const texts = useSelector(state => state.translate.texts);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [courseData, setCourseData] = useState();
    const [message, setMessage] = useState();
    const location = useLocation();
    const isDuplicateCourse = location.state?.isDuplicateCourse;

    useEffect(() => {
        async function getCoursesData() {
            coursesApi.coursesFilterIdPost(disciplinId, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.coursesFilterError, error: error, statusCode: response?.statusCode, message: "coursesFilterRangePost " + error.message, level: 2, component: "CoursesPage", line: 29 }))
                } else {
                    if (componentMounted.current) {
                        setCourseData({ ...resdata })
                    }
                }
            })
        }

        if (disciplinId)
            getCoursesData()
        else
            setCourseData({})

    }, [disciplinId])

    const handleChangeCourseDate = (newData) => {
        setCourseData(prevCourseData => ({ ...prevCourseData, ...newData }))
    }

    useEffect(() => {
        return () => {
            componentMounted.current = false;
        }
    }, [])

    return <div className={classes.DisciplineEdit}>
        {<BackArrow text={courseData && courseData.name ? courseData.name : texts.newCourse1} onClick={() => navigate("../")}></BackArrow>}

        {courseData &&
            <TabsMenu startTabIndex={isDuplicateCourse ? 1 : courseData && disciplinId ? 0 : 1} contentHeight={"calc(100vh - 254px)"} onDisabledClick={() => setMessage(texts.editTocError)}>
                <Tab disabeled={!courseData.id} name={texts.regularTopicTitle}>
                    <DisciplineEditTocs id={courseData?.id}></DisciplineEditTocs>
                </Tab>
                <Tab name={texts.editCurriculums}>
                    <DisciplineEditDetails handleChangeCourseDate={handleChangeCourseDate} courseData={courseData} id={courseData?.id}></DisciplineEditDetails>
                </Tab>
            </TabsMenu>
        }

        {message && <DynamicMessage type={"Error"} content={message} confirmFunc={() => setMessage(null)}></DynamicMessage>}
    </div>
}

export default DisciplineEdit;